import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const zendeskTemplate = {
	id: 'zendesk',
	guid: '7f8e1b23-9a6d-4cbb-8d0a-3c1f2e4a5b6c',
	name: 'Zendesk',
	category: TEMPLATE_CATEGORIES.SUPPORT,
	popularity: 'Enterprise',
	color: '#03363d',
	icon: 'mdi-lifebuoy',
	description: 'Customer support platform for ticket management and help desk operations.',
	features: ['API Token Auth', 'Ticket Management', 'Customer Support', 'SLA Tracking'],
	endpoints: [
		{
			name: 'Create New Ticket - Failed Connector Service Message',
			url: 'https://yourdomain.zendesk.com/api/v2/tickets.json',
			method: 'POST',
			description: 'Raise a ticket in Zendesk advising of a failed Connector Service message',
			cassieObjectID: -1,
			incrementField: 'FailureID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ServiceName', filter: '' },
				{ name: 'FailureID', filter: '' },
				{ name: 'OriginalResponseCode', filter: '' }
			],
			requestBody: '{ "ticket": { "subject": "Integration ID [PLACEHOLDER_INTEGRATIONID] has a failed message - Message ID [PLACEHOLDER_FAILUREID]", "comment": { "body": "Connector Service System [PLACEHOLDER_SERVICENAME] has a failed message with ID [PLACEHOLDER_FAILUREID].  The HTTP response code is [PLACEHOLDER_ORIGINALRESPONSECODE]." }, "priority": "urgent" } }',
			headers: [
				{ Name: 'Authorization', value: 'Bearer [ACCESS_TOKEN]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Create New Ticket - Failed Submissions',
			url: 'https://yourdomain.zendesk.com/api/v2/tickets.json',
			method: 'POST',
			description: 'Raise a ticket in Zendesk advising of a failed Cassie submission',
			cassieObjectID: -2,
			incrementField: 'SubmissionID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ErrorNumber', filter: '' },
				{ name: 'ErrorMessage', filter: '' },
				{ name: 'SubmissionID', filter: '' }
			],
			requestBody: '{ "ticket": { "subject": "The Cassie API has reported a failure for Submission ID [PLACEHOLDER_SUBMISSIONID]", "comment": { "body": "The Cassie API returned the following error details, [PLACEHOLDER_ERRORNUMBER], [PLACEHOLDER_ERRORMESSAGE]" }, "priority": "urgent" } }',
			headers: [
				{ Name: 'Authorization', value: 'Bearer [ACCESS_TOKEN]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Create New Ticket - New Cookie(s) Found',
			url: 'https://yourdomain.zendesk.com/api/v2/tickets.json',
			method: 'POST',
			description: 'Raise a ticket in Zendesk advising of a failed Cassie submission',
			cassieObjectID: -8,
			incrementField: 'ScanResultDateTime',
			resetIncrementValue: false,
			fields: [
				{ name: 'ScanID', filter: '' },
				{ name: 'CookieName', filter: '' },
				{ name: 'PreviousScanID', filter: '' }
			],
			requestBody: '{ "ticket": { "subject": "Scan No. [PLACEHOLDER_SCANID] has found a new Cookie - [PLACEHOLDER_COOKIENAME]", "comment": { "body": "The current scan no. [PLACEHOLDER_SCANID] found Cookie with name \'[PLACEHOLDER_COOKIENAME]\' which wasn\'t present in scan no. [PLACEHOLDER_PREVIOUSSCANID].  Please investigate." }, "priority": "urgent" } }',
			headers: [
				{ Name: 'Authorization', value: 'Bearer [ACCESS_TOKEN]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 200, message: '' }]
		}
	],
	defaults: {
		endpointAddress: 'https://[subdomain].zendesk.com/api/v2',
		authenticationTypeId: AUTH_TYPES.API_KEY,
		frequencyInSeconds: 0,
		notes: 'Zendesk customer support integration for ticket management and help desk operations. Replace [subdomain] with your Zendesk subdomain.'
	}
}
